module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "honor-dialog"
  }, [_c('el-dialog', {
    attrs: {
      "visible": _vm.isShow,
      "custom-class": "honor-tip-dialog",
      "top": "20vh",
      "width": "560px",
      "before-close": _vm.closeDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.isShow = $event
      }
    }
  }, [_c('img', {
    staticClass: "whale-logo",
    attrs: {
      "src": require("../images/personal_center/whale_logo.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "close-icon",
    attrs: {
      "src": require("../images/personal_center/close1.png"),
      "alt": ""
    },
    on: {
      "click": _vm.closeDialog
    }
  }), _vm._v(" "), _c('strong', [_vm._v("小鲸分析")]), _vm._v(" "), (_vm.isPass) ? [_c('p', {
    staticClass: "tips"
  }, [_vm._v("恭喜您申请成功！")]), _vm._v(" "), _c('p', {
    staticClass: "tips"
  }, [_vm._v("工作人员将在 1 个工作日内联系您，请您耐心等待。")])] : (_vm.isAllowApply) ? [_c('p', {
    staticClass: "tips"
  }, [_c('span', [_vm._v("申请核心用户需要 ")]), _vm._v(" "), _c('span', {
    staticClass: "consume"
  }, [_vm._v("消耗")]), _vm._v(" "), _c('span', [_vm._v(" 您当前以下金币：")])]), _vm._v(" "), _c('p', {
    staticClass: "tips"
  }, [_vm._v("1400 鲸币 = 500 普通鲸币 + 700 分享鲸币 + 200 专业鲸币")]), _vm._v(" "), _c('p', {
    staticClass: "tips"
  }, [_vm._v("请确认是否继续？")])] : [_c('p', {
    staticClass: "tips"
  }, [_c('span', [_vm._v("您当前的鲸币 ")]), _vm._v(" "), _c('span', {
    staticClass: "incompatible"
  }, [_vm._v("不符合")]), _vm._v(" "), _c('span', [_vm._v(" 核心用户最低的鲸币要求：")])]), _vm._v(" "), _c('p', {
    staticClass: "tips"
  }, [_vm._v("1400 鲸币 = 500 普通鲸币 + 700 分享鲸币 + 200 专业鲸币")]), _vm._v(" "), _c('p', {
    staticClass: "tips"
  }, [_vm._v("请继续加油！")])], _vm._v(" "), _c('div', {
    staticClass: "dialog-footer"
  }, [(!_vm.isPass) ? _c('span', {
    staticClass: "opera-btn",
    on: {
      "click": _vm.confirmClick
    }
  }, [_vm._v(_vm._s(_vm.isAllowApply ? '确认申请' : '获取鲸币'))]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "opera-btn",
    on: {
      "click": _vm.closeDialog
    }
  }, [_vm._v(_vm._s(_vm.isPass ? '知道了' : '取消'))])])], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-102a8739!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/honor_dialog.vue
// module id = kTqy
// module chunks = 15